import _toConsumableArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { MediaChromeButton } from "../media-chrome-button.js";
import { globalThis, document } from "../utils/server-safe-globals.js";
import { getStringAttr, setStringAttr } from "../utils/element-utils.js";
import { MediaUIAttributes } from "../constants.js";
var audioTrackIcon = "<svg aria-hidden=\"true\" viewBox=\"0 0 24 24\">\n  <path d=\"M11 17H9.5V7H11v10Zm-3-3H6.5v-4H8v4Zm6-5h-1.5v6H14V9Zm3 7h-1.5V8H17v8Z\"/>\n  <path d=\"M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0Z\"/>\n</svg>";
var slotTemplate = document.createElement("template");
slotTemplate.innerHTML = "\n  <slot name=\"icon\">".concat(audioTrackIcon, "</slot>\n");

var MediaAudioTrackButton = /*#__PURE__*/function (_MediaChromeButton) {
  _inherits(MediaAudioTrackButton, _MediaChromeButton);

  var _super = _createSuper(MediaAudioTrackButton);

  function MediaAudioTrackButton() {
    _classCallCheck(this, MediaAudioTrackButton);

    return _super.call(this, {
      slotTemplate: slotTemplate
    });
  }

  _createClass(MediaAudioTrackButton, [{
    key: "mediaAudioTrackEnabled",
    get: function get() {
      return getStringAttr(this, MediaUIAttributes.MEDIA_AUDIO_TRACK_ENABLED);
    },
    set: function set(id) {
      setStringAttr(this, MediaUIAttributes.MEDIA_AUDIO_TRACK_ENABLED, id);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(MediaAudioTrackButton), "observedAttributes", this)), [MediaUIAttributes.MEDIA_AUDIO_TRACK_ENABLED, MediaUIAttributes.MEDIA_AUDIO_TRACK_UNAVAILABLE]);
    }
  }]);

  return MediaAudioTrackButton;
}(MediaChromeButton);

if (!globalThis.customElements.get("media-audio-track-button")) {
  globalThis.customElements.define("media-audio-track-button", MediaAudioTrackButton);
}

var media_audio_track_button_default = MediaAudioTrackButton;
export { MediaAudioTrackButton, media_audio_track_button_default as default };